export default {
  // 页面标题
  'manualTag.title': '手动标签管理',
  
  // 表单字段
  'manualTag.form.tagName': '标签名称',
  'manualTag.form.tagNamePlaceholder': '请输入标签名称',
  'manualTag.form.tagNameRequired': '标签名称不能为空',
  'manualTag.form.tagNameMaxLength': '标签名称最多50个字符',
  'manualTag.form.tagDescription': '标签描述',
  'manualTag.form.tagDescriptionPlaceholder': '请输入标签描述（可选，仅后台可见）',
  'manualTag.form.tagDescriptionMaxLength': '标签描述最多255个字符',
  'manualTag.form.currencyScope': '适用币种',
  'manualTag.form.currencyPlaceholder': '请选择适用币种',
  'manualTag.form.currencyFilterPlaceholder': '全部币种',
  'manualTag.form.currencyRequired': '请至少选择一个币种',
  
  // 表格字段
  'manualTag.table.tagName': '标签名称',
  'manualTag.table.currencyScope': '适用币种',
  'manualTag.table.tagDescription': '标签描述',
  'manualTag.table.hitCount': '命中用户数',
  'manualTag.table.createTime': '创建时间',
  'manualTag.table.action': '操作',
  
  // 操作按钮
  'manualTag.action.create': '新增标签',
  'manualTag.action.editTags': '编辑标签',
  
  // 弹窗标题
  'manualTag.modal.createTitle': '新增标签',
  'manualTag.modal.editTitle': '编辑标签',
  'manualTag.modal.editMemberTagTitle': '编辑会员标签',
  'manualTag.modal.editHint': '点击复选框可以为会员添加或移除标签',
  
  // 提示消息
  'manualTag.message.createSuccess': '创建标签成功',
  'manualTag.message.createFailed': '创建标签失败',
  'manualTag.message.updateSuccess': '更新成功',
  'manualTag.message.updateFailed': '更新失败',
  'manualTag.message.deleteSuccess': '删除标签成功',
  'manualTag.message.deleteFailed': '删除标签失败',
  'manualTag.message.deleteConfirm': '确认删除此标签吗？',
  'manualTag.message.deleteWarning': '删除后，所有拥有此标签的会员将被移除该标签',
  
  // 其他
  'manualTag.noTags': '暂无标签',
  'manualTag.noTagsAvailable': '暂无可用标签，请先在标签管理中创建标签',
};
